// @flow
import React from 'react';
import { getMonthName } from 'utils/dateUtils';

type Props = {
  currentMonth: Date,
  handleIncrementCurrentMonth: Function,
  handleDecrementCurrentMonth: Function
};

const EventListPagination = (props: Props) => {
  const prevMonth = getMonthName(props.currentMonth.getMonth() === 0 ? 11 : props.currentMonth.getMonth() - 1);
  const nextMonth = getMonthName(props.currentMonth.getMonth() === 11 ? 0 : props.currentMonth.getMonth() + 1);
  return (
    <div className="events__pagination">
      <a
        role="button"
        tabIndex={0}
        onClick={props.handleDecrementCurrentMonth}
        title={`Voir les événements du mois de ${prevMonth}`}
        className="link-chevron link-chevron--center link-chevron--inline"
        data-label=""
      >
        <i className="icon icon-chevron-left is-inline" />
        <span>
          {prevMonth}{' '}
          {props.currentMonth.getMonth() > 0 ? props.currentMonth.getFullYear() : props.currentMonth.getFullYear() - 1}
        </span>
      </a>
      <a
        role="button"
        tabIndex={0}
        onClick={props.handleIncrementCurrentMonth}
        title={`Voir les événements du mois de ${nextMonth}`}
        className="link-chevron link-chevron--center link-chevron--inline"
        data-label=""
      >
        <span>
          {nextMonth}{' '}
          {props.currentMonth.getMonth() < 11 ? props.currentMonth.getFullYear() : props.currentMonth.getFullYear() + 1}
        </span>
        <i className="icon icon-chevron-right" />
      </a>
    </div>
  );
};

export default EventListPagination;
